export default "__VITE_ASSET__BaY8jpVu__"